export const REGISTER_PAGE_MAX_WIDTH = '865px'

const COURSELY_PUBLIC_SITE_BASE_URL = 'https://www.coursely.se' as const

type CourselyLanguageSegment = 'sv' | 'en' | 'no'

export const getCourselyLanguageSegment = (language?: string): CourselyLanguageSegment => {
  if (language === 'en' || language === 'no' || language === 'sv') {
    return language
  }
  return 'sv'
}

export const getCourselyPrivacyPolicyUrl = (language?: string) =>
  `${COURSELY_PUBLIC_SITE_BASE_URL}/${getCourselyLanguageSegment(language)}/privacy-policy`

// Used for "Användarvillkor" link in the registration flow
export const getCourselyUserConditionsUrl = (language?: string) =>
  `${COURSELY_PUBLIC_SITE_BASE_URL}/${getCourselyLanguageSegment(language)}/registration-rules-and-policy`
